module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "emit_above_planet_v4-1.71fc444d.png";